// extracted by mini-css-extract-plugin
export default {"wrap":"styles_wrap__Lcpav","thumbPreview":"styles_thumbPreview__lHfxl","clearIcon":"styles_clearIcon__QRsTs"};